<section
  *ngIf="isConnextDeviceInInitialConfig"
  class="fx-row custom-section fx-justify-end">
  <app-button-toggle-select
    [value]="mode$.value"
    [options]="[{
      value: 'inverters',
      label: labels.inverters | translate
    }, {
      value: 'sensors',
      label: labels.sensors
    }]"
    (valueChange)="mode$.next($any($event))">
  </app-button-toggle-select>
</section>

<ng-container *ngIf="isConnextDeviceInInitialConfig && mode$.value === 'sensors'">
  <section class="custom-section">
    <ng-container *ngTemplateOutlet="certifiedPlant"></ng-container>

    <customer-title-content
      [title]="labels.productionSensor"
      [content]="is3PhasePlant ? labels.productionSensorDescWithConstMultiplicative : labels.productionSensorDesc">
    </customer-title-content>
    <mat-form-field
      *ngIf="is3PhasePlant"
      subscriptSizing="dynamic"
      class="custom-mat-form-field w-full custom-border-bottom">
      <mat-select
        [placeholder]="labels.productionSensorPlaceholder"
        [formControl]="connextProductionSensor.controls.productionSensorK">
        <mat-option
          *ngFor="let _ of [].constructor(10); let index = index"
          class="tw-tabular-nums tw-font-normal tw-text-base"
          [value]="index + 1">
          {{ index + 1 }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <customer-simple-button
      [label]="labels.applyRegistration"
      [disabled]="isConnextProductionSensorInvalid"
      [action]="registerConnextProductionSensor">
    </customer-simple-button>
  </section>
</ng-container>

<ng-container *ngIf="mode$.value === 'inverters'">
  <ng-container *ngIf="connextInverterList.length">
    <section class="custom-section">
      <ng-container *ngTemplateOutlet="certifiedPlant"></ng-container>

      <customer-title-content
        [title]="labels.connextsInverters"
        [content]="labels.inverterListDescription">
      </customer-title-content>
      <section class="max-h-200 fx-r-col overflow-y-auto fx-gap-3 pt-3 border-t-1 border-greylight-100">
        <ng-container *ngFor="let inverter of connextInverterList.controls">
          <ng-container *ngIf="!inverter.controls.setup.value; else registration">
            <div class="fx-row fx-wrap fx-gap-3 pos-sticky inset-b-0 py-1 fx-g-1">
              <customer-simple-input
                class="fx-g-1 min-h-15"
                [placeholder]="labels.inverterListPlaceholder"
                [input]="inverter.controls.inverterSerial"
                [errorMessage]="inverter.controls.inverterSerial.errors | deviceSerialValidatorPipe : labels">
              </customer-simple-input>
              <customer-simple-button
                [label]="labels.setup"
                [disabled]="inverter.controls.inverterSerial.invalid"
                [action]="switchSetupConnextInverter(inverter)">
              </customer-simple-button>
            </div>
          </ng-container>

          <ng-template #registration>
            <app-card-accordion
              *ngIf="!inverter.controls.registered.value; else registered"
              class="pos-sticky inset-b-0 py-1 bg-white fx-g-1"
              [accordionLabel]="labels.inverterModbusDescription"
              [ngClass]="{
                'card-accordion-bg-grey': inverter.controls.inverterModbusId.status === 'INVALID',
                'card-accordion-bg-yellow': inverter.controls.inverterModbusId.status === 'VALID',
              }">
              <customer-item
                [deviceItemContent]="inverter.controls.inverterSerial.value || ''"
                [primaryAction]="{
                  classes: '',
                  icon: 'delete',
                  clickFn: switchSetupConnextInverter(inverter),
                }">
              </customer-item>
              <section
                class="p-3 body-2 text-300 text-grey-400"
                content>
                {{ labels.inverterModbusDescriptionInnerCard}}
                <customer-simple-input
                  class="my-3 d-block"
                  [placeholder]="labels.inverterModbusPlaceholder"
                  [input]="inverter.controls.inverterModbusId">
                </customer-simple-input>
                <customer-simple-button
                  [label]="labels.applyRegistration"
                  [disabled]="inverter.controls.inverterModbusId.invalid"
                  [action]="registerConnextInverter(inverter)">
                </customer-simple-button>
              </section>
            </app-card-accordion>
          </ng-template>

          <ng-template #registered>
            <app-card-accordion
              class="card-accordion-bg-green fx-g-1"
              mode="card">
              <customer-item
                [deviceItemContent]="(inverter.controls.inverterSerial.value || '') + ' - ' + labels.registered"
                [deviceItemSubContent]="'Modbus # ' + inverter.controls.inverterModbusId.value">
              </customer-item>
            </app-card-accordion>
          </ng-template>
        </ng-container>
      </section>
    </section>
  </ng-container>
</ng-container>

<section
  *ngIf="connextInverterList.length === 0"
  class="custom-section">
  <ng-container *ngTemplateOutlet="certifiedPlant"></ng-container>

  <app-card-accordion
    class="card-accordion-bg-green fx-g-1"
    mode="card"
    [accordionLabel]="labels.productionSensor">
    <customer-item
      svgIcon="customer_connext"
      [deviceItemContent]="(labels.productionSensor) + ' - ' + (labels.registered)"
      [deviceItemSubContent]="(labels.multiplicativeConstant) + ' ' + connextProductionSensor.controls.productionSensorK.value">
    </customer-item>
  </app-card-accordion>
</section>

<hr class="custom-section border-t-1 border-grey-100 mt-3" />

<section class="custom-section fx-row fx-align-baseline radius-4 mt-3 fx-justify-between">
  <customer-title-content
    [title]="labels.restoreDevicesAndSensors"
    [content]="labels.restoreDevicesAndSensorsDescription">
  </customer-title-content>
  <div class="fx-col fx-gap-1">
    <button
      *ngIf="applyChangeToCertifiedPlant"
      mat-button
      class="custom-mat-button-border text-grey-400"
      (click)="removeAllCurrentConnextDevices('uninstall')">
      {{ labels.uninstall }}
    </button>

    <button
      mat-button
      class="custom-mat-button-warning"
      (click)="removeAllCurrentConnextDevices('delete')">
      {{ applyChangeToCertifiedPlant ? labels.delete : labels.restore }}
    </button>
  </div>
</section>

<ng-template #certifiedPlant>
  <ng-container *ngIf="isVerifiedMode && (certifiedPlantDevices.length || certifiedPlantUninstalledDevices.length)">
    <customer-title-content
      [title]="labels.certifiedPlantsInverters"
      [content]="labels.certifiedPlantsInvertersDescription">
    </customer-title-content>

    <mat-chip-set>
      <mat-chip
        *ngFor="let opt of options"
        [ngStyle]="{
          '--mdc-chip-label-text-color': opt === 'active'
            ? 'var(--color-accent)' : opt === 'uninstalled'
              ? 'var(--color-grey-400)' : 'var(--color-red-400)',
        }"
        [ngClass]="{
          'bg-accent-100 text-accent border-accent': opt === 'active',
          'bg-grey-100 text-grey-400 border-grey-400': opt === 'uninstalled',
          'bg-red-100 text-red-400 border-red-400': opt === 'delete',
        }">
        {{ labels[opt] }}
      </mat-chip>

      <div class="border-r-1 border-grey-100 ml-2 border-grey-300 my-2"></div>

      <mat-chip
        *ngFor="let device of certifiedPlantDevices"
        style="--mdc-chip-label-text-color: var(--accent)"
        class="bg-accent-100 text-accent border-accent">
        {{ device.sn }}
      </mat-chip>
      <mat-chip
        *ngFor="let device of certifiedPlantUninstalledDevices"
        style="--mdc-chip-label-text-color: var(--grey-400)"
        class="bg-grey-100 text-grey-400 border-grey-400">
        {{ device.sn }}
      </mat-chip>
    </mat-chip-set>
  </ng-container>
</ng-template>
